import {axiosInstance} from '@/services/axiosInstance'

export  const MerchantContractResource = {
    
  getListPendingReview: (parametros) => {
    return axiosInstance.get(
      'v1/MerchantContract',
      {
        params: parametros
      }
    )
  },

    getByIdMerchant: parametros => {
     const  headersa = { 'content-type': 'text/html; charset=utf-8'}
        return axiosInstance.get("v1/merchantcontract/:idMerchant/print", {
          urlParams: parametros
        }, { headers: headersa, responseType :"text/html" } );
      }

 
}